import CloudinaryReportFormFilterMain from "./filter-main-form";


const CloudinaryReportForms = {
    FilterMain : CloudinaryReportFormFilterMain,
}

export default CloudinaryReportForms;